import { ReactNode } from "react"
import { FormControlLabel, Switch, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    chip: {
        margin: 0,
        gap: ".5rem",
        height: "2.5rem",
        padding: "0 .875rem",
        borderRadius: "6.25rem",
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
        background: theme.palette.background.paper,
        whiteSpace: "nowrap",
        "& .MuiFormControlLabel-label": {
            display: "inline-flex",
            alignItems: "center",
            gap: ".5rem",
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
            color: theme.palette.common.white,
        },
        "& .MuiSwitch-track": {
            opacity: 1,
            background: theme.palette.tailwind.slate[300],
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            opacity: 1,
            background: theme.palette.tailwind.amber[500],
        },
    },
    chipChecked: {
        background: theme.palette.tailwind.amber[50],
        borderColor: theme.palette.tailwind.amber[200],
    },
    label: {
        fontWeight: 600,
        color: theme.palette.tailwind.slate[800],
    },
    labelChecked: {
        color: theme.palette.tailwind.amber[600],
    },
    count: {
        padding: "0 .5rem",
        borderRadius: "6.25rem",
        fontWeight: 700,
        background: theme.palette.tailwind.amber[100],
        color: theme.palette.tailwind.amber[600],
    },
    countChecked: {
        background: theme.palette.tailwind.amber[500],
        color: theme.palette.common.white,
    },
}))

type Props = Readonly<{
    isChecked: boolean
    count?: number
    onChange: (isChecked: boolean) => void
    children: ReactNode
    className?: string
}>

export function StandardFilterToggleChip({ isChecked, count, onChange, children, className }: Props) {
    const { classes, cx } = useStyles()

    return (
        <FormControlLabel
            className={cx(classes.chip, isChecked && classes.chipChecked, className)}
            control={<Switch size="small" checked={isChecked} onChange={(_, checked) => onChange(checked)} />}
            label={
                <>
                    <Typography
                        variant="body2"
                        component="span"
                        className={cx(classes.label, isChecked && classes.labelChecked)}
                    >
                        {children}
                    </Typography>
                    {count !== undefined && (
                        <Typography
                            variant="body2"
                            component="span"
                            className={cx(classes.count, isChecked && classes.countChecked)}
                        >
                            {count}
                        </Typography>
                    )}
                </>
            }
        />
    )
}
